
import * as React from 'react';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';
import { ControlFacet } from '../models/controls/ControlFacet';

/**
 * @public
 */
export interface IGetDownloadData {
    url: string;
    method: 'GET';
}

/**
 * @public
 */
export interface IPostDownloadData {
    url: string;
    method: 'POST';
    postData: { [key: string]: string; };
}

/**
 * @public
 */
export type IDownloadData = IGetDownloadData | IPostDownloadData;

/**
 * @public
 */
export interface IDownloaderProps {
    resolve: () => void;
    reject: (error: Error) => void;
    itemKeys: string[];
    getDownloadData: () => Promise<IDownloadData>;
}

/**
 * @public
 */
export const downloadItemsActionControlFacet: ControlFacet<{
    itemKeys: string[];
}, {
        isAvailable: boolean;
        downloader: React.ComponentType<IDownloaderProps>;
        getDownloadData: () => IItemCacheThunkAction<Promise<IDownloadData>>;
    }> = new ControlFacet('downloadItemsActionControl');
